/**
 * This class should be used to manipulate the subtotals around the site.
 *
 * Totals work on a cents based number so if you're working with 2450 yen the value should be 245000
 */

export default class TotalManipulator extends EventTarget {
  constructor(cart) {
    super();

    this.changes = {};
    this.init(cart);
  }

  init(cart) {
    this.setCart(cart);
  }

  setCart(cart) {
    this.total = cart.original_total_price + this.totalChanges() - window.SolarisCart.protectionsTotalCost();

    this.updateCurrencies();
  }

  getChange(key) {
    return this.changes[key] || 0;
  }

  change(value) {
    if (value && !Number.isNaN(value)) {
      this.total += value;
      this.updateCurrencies();
    }
  }

  changeBy(key, value) {
    if (value && !Number.isNaN(value)) {
      this.changes[key] = (this.changes[key] || 0) + value;
      this.change(value);
    }
  }

  clearChangesByKey(key) {
    if (this.changes[key]) {
      this.change(-this.changes[key]);
      delete this.changes[key];
    }
  }

  subtractChange(key, value) {
    if (this.changes[key]) {
      return value - this.changes[key];
    }

    return value;
  }

  totalChanges() {
    return Object.values(this.changes).reduce((total, value) => total + value, 0);
  }

  updateCurrencies() {
    const path = window.location.pathname;

    document.querySelectorAll('.cart__subtotal .money').forEach((node) => {
      TotalManipulator.updateElement(node, this.total);
    });

    if (path.includes('/cart') && EasyPoints?.Register) {
      document.querySelectorAll('[data-loyal-target="total_price"]').forEach((node) => {
        node.setAttribute('data-loyal-total-price', this.total);
      });
      document.querySelectorAll('[data-loyal-target="total-points-value"]').forEach((node) => {
        node.setAttribute('data-loyal-currency-cost', this.subtractChange('shippingProtection', this.total));
      });
      EasyPoints.Points.insertTotalPoints(document);
    }

    this.dispatchEvent(
      new CustomEvent('update-cart', {
        detail: {
          total: this.total,
        },
      }),
    );
  }

  static updateElement(el, yen) {
    const { attributes } = el;

    for (let i = 0; i < attributes.length; i += 1) {
      const attribute = attributes[i];
      if (attribute.nodeName.includes('data-currency-')) {
        const currency = attribute.nodeName.substring(14).toUpperCase();
        const format = Currency.moneyFormats[currency].money_format;
        const convertedTotal = Currency.convert(yen, shopCurrency, currency);
        const formattedTotal = Currency.formatMoney(convertedTotal, format);
        el.setAttribute(`data-currency-${currency.toLowerCase()}`, formattedTotal);
      }
    }

    const currency = Currency.currentCurrency;
    const format = Currency.moneyFormats[currency].money_format;
    const convertedTotal = Currency.convert(yen, shopCurrency, currency);
    el.innerHTML = Currency.formatMoney(convertedTotal, format);
  }
}
